import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Center,
} from "@chakra-ui/react";
import {
  getAuth,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Nav from "../NavBar";
import { Link as ReactRouterLink } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { useState } from "react";
import { doc, getFirestore, setDoc } from "firebase/firestore";
import toast, { Toaster } from 'react-hot-toast';

const googleAuthProvider = new GoogleAuthProvider();

export default function SignupPage() {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const afterSignup = async (user, allowMarketingEmails) => {
    if (user) {
      await setDoc(doc(getFirestore(), `userPreferences/${user.uid}`), {
        marketingEmails: allowMarketingEmails,
      });
    }

    navigate("/");
    toast.success("Your account was created succesfully 🥳")
  };

  const signUp = async (data) => {
    setSubmitting(true);
    createUserWithEmailAndPassword(getAuth(), data.email, data.password)
      .then((userCred) => afterSignup(userCred.user, data.marketing))
      .catch((error) => {
        console.error(error);
        setSubmitting(false);
        const msg =
          {
            "auth/email-already-in-use":
              "Email already in use, please sign in instead.",
            "auth/invalid-email": "Invalid email, please try again.",
            "auth/weak-password": "Please pick a longer password",
          }[error.code] || "Something went wrong. Please try again.";
        setError(msg);
      });
  };

  return (
    <Flex direction={"column"} minH={"100vh"}>
      <Nav />
      <Flex minH={"100%"} align={"center"} justify={"center"}>
        <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
          <Stack align={"center"}>
            <Heading fontSize={"4xl"}>Sign up for Wordbase</Heading>
            <Text fontSize={"lg"} color={"gray.600"}>
              to enjoy all of our cool features ✌️
            </Text>
          </Stack>
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow={"lg"}
            minWidth={"md"}
            p={8}
          >
            <form onSubmit={handleSubmit(signUp)}>
              <Stack spacing={4}>
                <FormControl id="email">
                  <FormLabel>Email address</FormLabel>
                  <Input {...register("email")} type="email" required />
                </FormControl>
                <FormControl id="password">
                  <FormLabel>Password</FormLabel>
                  <Input
                    {...register("password")}
                    type="password"
                    required
                    minLength={8}
                  />
                </FormControl>
                <Stack spacing={10}>
                  <Stack
                    direction={{ base: "column", sm: "row" }}
                    align={"start"}
                    justify={"space-between"}
                  >
                    <Checkbox {...register("marketing")}>
                      I want to receive marketing emails
                    </Checkbox>
                  </Stack>
                  <Stack spacing={2}>
                    {error && <Text color={"red.600"}>{error}</Text>}
                    <Button
                      type="submit"
                      bg={"purple.400"}
                      color={"white"}
                      _hover={{
                        bg: "purple.500",
                      }}
                      isLoading={submitting}
                    >
                      Sign up
                    </Button>
                    <Text
                      textAlign={"center"}
                      fontWeight={"semibold"}
                      opacity={0.8}
                    >
                      or
                    </Text>
                    <Button
                      w={"full"}
                      maxW={"md"}
                      variant={"outline"}
                      leftIcon={<FcGoogle />}
                      onClick={() => {
                        setSubmitting(true);
                        signInWithPopup(getAuth(), googleAuthProvider).then(
                          () => afterSignup()
                        );
                      }}
                    >
                      <Center>
                        <Text>Sign in with Google</Text>
                      </Center>
                    </Button>
                    {/* <Button
                      w={"full"}
                      maxW={"md"}
                      colorScheme={"facebook"}
                      leftIcon={<FaFacebook />}
                    >
                      <Center>
                        <Text>Continue with Facebook</Text>
                      </Center>
                    </Button> */}
                  </Stack>
                </Stack>
                <Text>
                  Already have an account?&nbsp;
                  <Link
                    as={ReactRouterLink}
                    to={"/signin"}
                    color={"purple.400"}
                    href="/signin"
                  >
                    Sign in instead.
                  </Link>
                </Text>
              </Stack>
            </form>
          </Box>
        </Stack>
      </Flex>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </Flex>
  );
}
